import { useEffect, type RefObject } from "react";
import { withRouter } from "react-router-dom";

// Declare window.sideContent type for TypeScript
declare global {
	interface Window {
		sideContent?: RefObject<HTMLElement>;
	}
}

function ScrollToTop({ history }) {
	useEffect(() => {
		const unlisten = history.listen(() => {
			window.sideContent?.current?.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		});
		return () => {
			unlisten();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
}

export default withRouter(ScrollToTop);
